import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoutingStateService implements OnDestroy {

  history = [];

  sub: Subscription;

  private showHeaderLogo = new BehaviorSubject<boolean>(false);

  constructor(
    private router: Router
  ) {}

  ngOnDestroy() {
    if (!!this.sub) {
      this.sub.unsubscribe();
    }
  }

  trackRouting() {
    this.sub = this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(({urlAfterRedirects}: NavigationEnd) => {
      this.history = [...this.history, urlAfterRedirects];
    });
  }

  untrackRouting() {
    this.sub.unsubscribe();
  }

  getHistory() {
    return this.history;
  }

  getPreviousUrl() {
    return this.history.length > 1 ? this.history[this.history.length - 2] : '/';
  }

  setShowHeaderLogo(value: boolean) {
    this.showHeaderLogo.next(value);
  }

  public get getShowHeaderLogo(): Observable<boolean> {
    return this.showHeaderLogo.asObservable();
  }

}
